export const formatCurrencyToSave = (value: number | string) => {
  let formatValue = String(value);
  formatValue = formatValue.replace(/\.|\,/g, "");
  formatValue = `${formatValue.substring(0, formatValue.length - 2)}.${formatValue.substring(formatValue.length - 2,formatValue.length )}`
  return Number(formatValue)
}